import { getNavigatorLanguages } from "./getNavigatorLanguages";
import { DateTimeFormat } from "./temporal";
export const IntlFormats = {
    "number": Intl.NumberFormat,
    "relativeTime": Intl.RelativeTimeFormat,
    "dateTime": DateTimeFormat,
};
const supportedLocaleCache = {};
export function getSupportedFormatLocale(format) {
    var _a;
    return (_a = supportedLocaleCache[format]) !== null && _a !== void 0 ? _a : findSupportedFormatLocale(format);
}
function findSupportedFormatLocale(format) {
    var _a;
    const formatCtor = IntlFormats[format];
    const locale = (_a = getNavigatorLanguages()
        .find(locale => locale == new formatCtor(locale).resolvedOptions().locale)) !== null && _a !== void 0 ? _a : "default";
    supportedLocaleCache[format] = locale;
    return locale;
}
//# sourceMappingURL=getSupportedFormatLocale.js.map